// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__176lv","title":"card_title__14Mtc","inActive":"card_inActive__egpsz"};